<template>
  <div class="account-login">
    <div class="account-login-content">
      <div class="input-box">
        <em class="login-icon iconfont icon-login-account"></em>
        <input
          v-model="account"
          class="input"
          :placeholder="letter.accountName"
          @focus="initViewport"
        />
      </div>
      <div class="input-box">
        <em class="login-icon iconfont icon-login-password"></em>
        <input
          v-model="password"
          :placeholder="letter.password"
          class="input"
          type="password"
        />
      </div>
      <div class="bottom">
        <div
          class="select-text"
          @click="toggleRemember"
          :class="{ active: isRemember }"
        >
          {{ letter.remember }}
        </div>
        <div class="forget-password" @click="jumpFindPwd">
          {{ letter.forgetPwd }}
        </div>
      </div>

      <div class="account-login-btn j-account-login-btn" @click="accountLogin">
        {{ letter.login }}
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { initViewport } from '@utiles/officialStore/index';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
import {
  UPDATE_LOADING,
  SWITCH_SERVER,
  UPDATE_PC_SERVER_ID,
  UPDATE_ROLE_LIST,
  GET_SERVER_LIST
} from '@store/officialWebStore/';
import {
  TOGGLE_REMEMBER,
  GO_ACCOUNT_LOGIN
} from '@store/officialWebStore/login';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();
export default {
  name: 'accountLogin',
  data() {
    return {
      account: '',
      password: '',
      loading: false,
      canAccountLogin: true
    };
  },
  methods: {
    checkInputValid() {
      if (!this.account.length) {
        alert(this.letter.accountName);
        return false;
      }
      if (!this.password.length) {
        alert(this.letter.password);
        return false;
      }
      return true;
    },
    accountLogin() {
      clickButton({
        btnName: 'account_login_confirm',
        locationKey: locationType.loginPopup
      });
      if (!this.checkInputValid()) {
        return;
      }
      if (!this.canAccountLogin) {
        return;
      }
      this.canAccountLogin = false;
      this.loading = true;
      this.$store.commit(UPDATE_LOADING, true);
      this.$store
        .dispatch(GO_ACCOUNT_LOGIN, {
          account: this.account,
          password: this.password
        })
        .then(res => {
          this.loading = false;
          this.canAccountLogin = true;
          this.$store.commit(UPDATE_LOADING, false);
          if (res.result) {
            this.$store.commit(SWITCH_SERVER, 0);
            this.$store.commit(UPDATE_PC_SERVER_ID, 0);
            this.$store.commit(UPDATE_ROLE_LIST, []);
            this.$store.dispatch(GET_SERVER_LIST).then(_serverList => {
              this.$store.commit(UPDATE_LOADING, false);
            });
          } else {
            alert(res.msg);
          }
        });
    },
    jumpFindPwd() {
      clickButton({
        btnName: 'find_password',
        locationKey: locationType.loginPopup
      });
      const link = getGlobalGetGotoLink({
        link: `https://pay.${mainHost}/platform/passport.html?gameId=${this.gameId}&appLanguage=${this.$store.state.lang}&language=${this.$store.state.lang}#/findPwd`
      });
      sdkOpenLink({ link: link });
    },
    toggleRemember() {
      this.$store.commit(TOGGLE_REMEMBER);
    },
    initViewport
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      isRemember: state => state.login.isRemember,
      gameId: state => state.gameId
    })
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.account-login {
  padding: 0 58px;
  font-size: 22px;
  color: #333;
  &-content {
    width: 603px;
    @media screen and (orientation: landscape) {
      width: 100%;
    }
  }
  .input-box {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #d2d2d2;
    margin-bottom: 30px;
    .login-icon {
      font-size: 30px;
      color: #555;
      margin-right: 16px;
    }
    .label {
      margin-right: 10px;
      flex-shrink: 0;
    }
    .input {
      flex: 1;
      font-weight: bold;
      font-size: 22px;
      -webkit-box-shadow: 0 0 0 1000px #fff inset;
    }
  }

  &-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px auto;
    line-height: 80px;
    height: 80px;
    font-size: 24px;
    color: #fff;
    font-weight: bold;
    background: $btnBg;
    border-radius: 10px;
    cursor: pointer;
  }
  .bottom {
    display: flex;
    justify-content: space-between;
  }
  .forget-password {
    cursor: pointer;
  }
  .select-text {
    cursor: pointer;
    display: inline-block;
    font-weight: 400;
    line-height: 19px;
    padding-left: 30px;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    &::before {
      content: '';
      border-color: transparent #fff #fff transparent;
      border-radius: 0 2px 1px;
      border-style: solid;
      border-width: 1px 3px 3px 1px;
      height: 15px;
      width: 9px;
      position: absolute;
      top: 3px;
      left: 1px;
      opacity: 0;
      transform: rotate(37deg);
      transform-origin: 100% 100%;
      transition: opacity 0.2s ease-out;
      z-index: 1;
      box-sizing: border-box;
    }
    &::after {
      content: '';
      background-color: #fff;
      border: 1px solid #b9c4c9;
      border-radius: 3px;
      height: 20px;
      width: 20px;
      position: absolute;
      left: 0;
      top: 0;
      transition: background 0.15s ease-out, border 0.05s ease-out,
        box-shadow 0.1s ease-out;
      z-index: 0;
    }
    &.active {
      &::before {
        opacity: 1;
      }
      &::after {
        background-color: var(--btnBg);
        border-color: var(--borderActive);
        box-shadow: 0 0 0 1px var(--btnBg);
      }
    }
  }
}
</style>
